module.exports = __webpack_public_path__ + "media/6.249bccfa.mp3";